// extracted by mini-css-extract-plugin
export var backupIcon = "_s8-1";
export var image = "_s8-0";